import { Shield, AlertTriangle, Zap } from 'lucide-react';
import {
  formatMiningDate as formatDate,
  formatMiningDateShort as formatDateShort,
} from '../../../utils/dateUtils';

// Brand: Teal #45B7AA, Charcoal #2D3142
export const varianceStates = {
  normal: {
    key: 'normal',
    label: 'Clear',
    icon: Shield,
    bg: 'bg-teal-50',
    text: 'text-teal-700',
    border: 'border-teal-200',
    dot: 'bg-teal-500',
    badgeBg: 'bg-teal-50',
    badgeBorder: 'border-teal-200',
    badgeText: 'text-teal-700',
    rowBg: '',
    accent: 'var(--accent)',
    chartColor: '#45B7AA',
  },
  watch: {
    key: 'watch',
    label: 'Watch',
    icon: AlertTriangle,
    bg: 'bg-amber-50',
    text: 'text-amber-700',
    border: 'border-amber-200',
    dot: 'bg-amber-500',
    badgeBg: 'bg-amber-50',
    badgeBorder: 'border-amber-200',
    badgeText: 'text-amber-700',
    rowBg: 'bg-amber-50/50',
    accent: 'var(--warning)',
    chartColor: '#d97706',
  },
  alert: {
    key: 'alert',
    label: 'Alert',
    icon: Zap,
    bg: 'bg-red-50',
    text: 'text-red-700',
    border: 'border-red-200',
    dot: 'bg-red-500',
    badgeBg: 'bg-red-50',
    badgeBorder: 'border-red-200',
    badgeText: 'text-red-700',
    rowBg: 'bg-red-50/50',
    accent: 'var(--danger)',
    chartColor: '#dc2626',
  },
};

export const getVarianceState = (currentStreak, streakDaysToAlert) => {
  if (!currentStreak || currentStreak === 0) return varianceStates.normal;
  if (currentStreak < streakDaysToAlert) return varianceStates.watch;
  return varianceStates.alert;
};

export const formatVariance = (value) => {
  if (value == null) return '--';
  const num = parseFloat(value);
  return `${num >= 0 ? '+' : ''}${num.toFixed(2)}%`;
};

export const formatWeight = (value) => {
  if (value == null || parseFloat(value) === 0) return '--';
  return parseFloat(value).toLocaleString('en', { maximumFractionDigits: 1 });
};

export { formatDate, formatDateShort };

export const DAY_RANGES = [
  { label: '7D', value: 7 },
  { label: '14D', value: 14 },
  { label: '21D', value: 21 },
  { label: '28D', value: 28 },
];
